import { Box, Center, Flex, Image } from "@chakra-ui/react";
import React, { useEffect } from "react";
import GitHubCalendar from "react-github-calendar";
import ReactTooltip from "react-tooltip";
import HeadingCompo from "../AboutMe/HeadingCompo";
import GlassyBox from "../customComponents/GlassyBox";

import "aos/dist/aos.css";
const GithubCalendar = () => {
  return (
    <Box>
      <HeadingCompo>Github Stats</HeadingCompo>
      <Center mt="30px">
        <GlassyBox width={"fitcontent"}>
          <Flex align="center">
            <Box mr="20px">
              <Image
                draggable={false}
                src="https://github-readme-stats.vercel.app/api/top-langs/?username=faizal-siddiqui&layout=compact&show_icons=true&theme=gotham&hide_border=true"
                alt="faizal-stats"
              />
            </Box>
            <Box>
              <Image
                draggable={"false"}
                src="https://github-readme-stats.vercel.app/api?username=faizal-siddiqui&show_icons=true&theme=gotham&hide_border=true"
                alt="faizal-stats"
              />
            </Box>
          </Flex>
        </GlassyBox>
      </Center>
      <Center mt={{ lg: "70px", md: "50px", sm: "30px" }}>
        <GlassyBox width={"fitcontent"}>
          <GitHubCalendar
            username="faizal-siddiqui"
            color="#89D5D2"
            children={<ReactTooltip html />}
          />
        </GlassyBox>
      </Center>
    </Box>
  );
};

export default GithubCalendar;
